import { defineSlotRecipe } from '@chakra-ui/react';

export const supportSlotRecipe = defineSlotRecipe({
    slots: [
        'bgWrapper',
        'button',
        'checkOurOfferBox',
        'contactInfoBox',
        'container',
        'emailLink',
        'hotlineAvailability',
        'image',
        'subHeader',
        'userTypesWrapper',
        'userTypeBox',
    ],
    base: {
        bgWrapper: {
            bg: 'secondary.50',
        },
        container: {
            maxW: 'containerWidth',
            m: '0 auto',
            px: { base: 'gutterWidth', md: 'gutterWidthDesktop' },
            py: { base: 8, md: 16 },
            flexDirection: { base: 'column', lg: 'row' },
        },
        subHeader: {
            mb: 6,
            fontSize: 'md',
        },
        contactInfoBox: {
            flexDirection: 'column',
            flex: '2',
            px: 0,
        },
        userTypesWrapper: {
            flexDirection: { base: 'column', lg: 'row' },
            gap: {
                base: 0,
                md: 2,
            },
        },
        userTypeBox: {
            flexBasis: { base: '100%', lg: '50%' },
            mb: { base: 6, md: 0 },
        },
        emailLink: {
            fontSize: 'md',
        },
        hotlineAvailability: {
            ml: {
                base: 7,
                md: 0,
            },
            fontSize: 'xs',
            color: 'gray.600',
        },
        checkOurOfferBox: {
            bg: 'secondary.100',
            flex: '1',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'start',
            minH: '280px',
            position: 'relative',
            p: 6,
            mt: 2,
            borderRadius: 'lg',
        },
        image: {
            position: 'absolute',
            width: '75%',
            height: '90%',
            right: '2rem',
        },
        button: {
            colorPalette: 'secondary',
        },
    },
});
